/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, Input } from '@angular/core';
import { Tour } from '@shared/models';

@Component({
    selector: 'app-tour-item-drivers',
    templateUrl: './tour-item-drivers.component.html',
    styleUrls: ['./tour-item-drivers.component.scss'],
    standalone: false
})
export class TourItemDriversComponent {

  @Input() tour: Tour;

  public fixedAssignmentStatus = 'teams_scheduled';

  constructor() { }
}
